import React from 'react';
import { Navigate } from 'react-router-dom';

// This component redirects to login since signup is handled in LoginForm
const SignupForm = () => {
  return <Navigate to="/login" replace />;
};

export default SignupForm;
